module.exports = __webpack_public_path__ + "noDataChart.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/noDataChart.svg
// module id = 321
// module chunks = 0